import "./Button.scss"
import React, { PropTypes } from "react"
import classnames from "classnames"
import { Route, Link } from "react-router-dom"

const LinkButton = ({ to, className, ...rest }) => {
  return (
    <Route
      to={to}
      children={({ match }) => (
        <Link
          {...rest}
          className={classnames(match && "Button-active", className)}
          to={to}
        />
      )}
    />
  )
}

const Button = ({
  to,
  href,
  small,
  large,
  active,
  styleType,
  children,
  onClick,
  className,
}) => {
  const size = large ? "large" : small ? "small" : "medium"
  const Component = to ? LinkButton : href ? "a" : "button"
  const classes = classnames(
    "Button",
    `Button-${styleType}`,
    `Button-${size}`,
    { "Button-active": active },
    className
  )

  return (
    <Component onClick={onClick} className={classes} href={href} to={to}>
      {children}
    </Component>
  )
}

Button.displayName = "Button"

Button.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]).isRequired,
  styleType: PropTypes.oneOf(["primary", "text", "empty", "tab"]).isRequired,
}

Button.defaultProps = {
  size: "medium",
  styleType: "primary",
}

export default Button



// WEBPACK FOOTER //
// ./src/lib/Button.js